<template>
  <div v-if="accessToken" :class="isFullscreen ? 'fullChat-box' : 'chat-box'">
    <iframe :src="`${env}/#/chat/${accessToken}`" style="width: 100%; height: 100%" frameborder="0" ref="iframeRef"
      allow="microphone" @load="handleIframeLoad"></iframe>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";

export default {
  name: 'ChatBox',
  props: {
    accessToken: {
      type: String,
      default: null
    },
    isFullscreen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      iframeRef: null,
      env: process.env.VUE_APP_BASE_AI_API
    };
  },
  mounted() {
    // 在 mounted 中获取 iframe 的 ref
    this.iframeRef = this.$refs.iframeRef;
  },
  methods: {
    postAuthMessage() {
      if (!this.iframeRef?.contentWindow) {
        return;
      }
      const token = getToken();
      const theme = this.$store.state.settings.Skin;
      const themeColor = this.$store.state.settings.theme;
      this.iframeRef.contentWindow.postMessage(
        {
          type: 'IFRAME_AUTH_INFO',
          token,
          theme,
          themeColor
        },
        '*'
      );
    },

    handleIframeLoad() {
      this.postAuthMessage();
    }
  }
};
</script>

<style lang="less">
::-webkit-scrollbar-thumb {
  background-color: var(--td-scrollbar-color);
}

::-webkit-scrollbar-thumb:horizontal:hover {
  background-color: var(--td-scrollbar-hover-color);
}

::-webkit-scrollbar-track {
  background-color: var(--td-scroll-track-color);
}

.chat-box {
  height: 55vh;
}

.fullChat-box {
  height: 96vh;
}

.t-chat__base {
  padding-left: 0 !important;
}

.t-chat__detail {
  background: #f3f3f3;
  border-radius: 12px;
}

.t-chat__inner .t-chat__avatar {
  padding-top: 0;
}

.t-chat__text {}

.t-chat__avatar__box {
  padding-top: 0 !important;
}

.model-select {
  display: flex;
  align-items: center;

  .t-select {
    width: 112px;
    height: var(--td-comp-size-m);
    margin-right: var(--td-comp-margin-s);

    .t-input {
      border-radius: 32px;
      padding: 0 15px;
    }

    .t-input.t-is-focused {
      box-shadow: none;
    }
  }

  .check-box {
    width: 112px;
    height: var(--td-comp-size-m);
    border-radius: 32px;
    border: 0;
    background: var(--td-bg-color-component);
    color: var(--td-text-color-primary);
    box-sizing: border-box;
    flex: 0 0 auto;

    .t-button__text {
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        margin-left: var(--td-comp-margin-xs);
      }
    }
  }

  .check-box.is-active {
    border: 1px solid var(--td-brand-color-focus);
    background: var(--td-brand-color-light);
    color: var(--td-text-color-brand);
  }
}
</style>